export default __webpack_public_path__ + "static/media/Paws_up_login.ebe4ae14.jpg";